import {useState,useEffect} from "react";
import LayoutPages from './../../components/LayoutPages/LayoutPages';
import DataState from "./../../components/ui/DataState";
import useDataStatus from "./../../components/ui/useDataStatus";
import TitlePage from './../../components/Pages/Title/Title';

import { Calendar, momentLocalizer,Views } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment'

import Modal from '@mui/material/Modal';

import './Program.scss';
import ProgramAddDay from './../../components/Programar/AddDay/AddDay';
import 'moment/locale/es';

import axios from 'axios';
import { useAuthContext } from './../../context/authContext';
import ModalRightCont from './../../components/ModalRightCont/ModalRightCont';

const localizer = momentLocalizer(moment);

const ETIQUETA = { starter: 'Entrada', drinks: 'Bebida', snacks: 'Snack', breakfast: 'Desayuno' };

/** "Lunes 5 de octubre", con mayuscula: es el titulo de la ventana. */
const fechaLarga = (d) => {
  const t = moment(d).format('dddd D [de] MMMM');
  return t.charAt(0).toUpperCase() + t.slice(1);
};

const mesLargo = (d) => {
  const t = moment(d).format('MMMM YYYY');
  return t.charAt(0).toUpperCase() + t.slice(1);
};

/** Las semanas del mes, solo de lunes a viernes. */
const semanasDelMes = (d) => {
  const inicio = moment(d).startOf('month').startOf('isoWeek');
  const fin = moment(d).endOf('month').endOf('isoWeek');
  const semanas = [];
  for (let s = inicio.clone(); s.isBefore(fin); s.add(1,'week')) {
    semanas.push(Array.from({length:5},(_,i)=>s.clone().add(i,'days')));
  }
  return semanas;
};

const PageProgram = (props) => {

    const { token, baseUrl } = useAuthContext();
    const { status, start, done, fail } = useDataStatus();

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    
    moment.locale('es');
    const [dateSelect,setDateSelect] = useState();
    const [eventList,setEventList] = useState([]);

    const [view, setView] = useState(Views.MONTH);
    const [date, setDate] = useState(new Date());

    /* El menu de cada dia, tal cual: {fecha: {platos:[...], extras:[...]}}.
       Antes esto se aplanaba a una lista de "eventos" sueltos, uno por cada
       tipo de menu, y el calendario los pintaba en fila. Como la cena es
       siempre el mismo plato que el almuerzo, cada dia salia con sus tres
       platos repetidos en dos colores y los nombres cortados. */
    const [menuPorDia,setMenuPorDia] = useState({});

    const getEvents = () =>{
        start();
        const iniDate = moment(date).startOf('month').subtract(7,'days').format('YYYY-MM-DD');
        const endDate = moment(date).endOf('month').add(7,'days').format('YYYY-MM-DD');

        axios.get(baseUrl+'menu/schedule?startDate='+iniDate+'&endDate='+endDate,
            {headers: {"Authorization" : `Bearer ${token}`} }
        )
        .then((resp)=>{
            const mapa = {};
            (resp.data.data || []).forEach((dia)=>{
                const clave = moment(dia.localDate).format('YYYY-MM-DD');
                const platos = [];
                const extras = [];
                (dia.menuTypeGroups || []).forEach((grupo)=>{
                    (grupo.menuTypes || []).forEach((mt)=>{
                        const nombre = mt.menu?.name || '';
                        /* La cena no se lista: es el mismo plato del almuerzo
                           todos los dias. Lo que se cocina es una olla. */
                        if (grupo.type === 'lunch') platos.push({ id: mt.id, nombre });
                        else if (grupo.type !== 'dinner') extras.push({ tipo: grupo.type, nombre });
                    });
                });
                mapa[clave] = { platos, extras };
            });
            setMenuPorDia(mapa);
            done();
        }).catch((errr)=>{
            console.log(errr)
            fail();
        })
    }

    const [menusList,setMenusList] = useState();
    const [menusListFilter,setMenusListFilter] = useState();
    const [catList,setCatList] = useState();
    const [catSelect,setCatSelect] = useState();

    const [searchTxt,setSearchTxt] = useState('');

    const getMenus = ()=>{
        axios.get(baseUrl+'menu',{
            headers: {"Authorization" : `Bearer ${token}`} 
        }).then((resp)=>{

            setMenusList(resp.data.data);
            setMenusListFilter(resp.data.data);

            const listTmp = resp.data.data;

            const uniqueTypes = [...new Set(
                listTmp.flatMap(item => item.types || [])
            )];


            setCatList(uniqueTypes);

        }).catch((error)=>{
            console.log('===>',error)
        });
    }

    const filterMenus = (cat, txtField) => {
        const filtered = menusList.filter((item) => {
        const matchCategory = !cat || item.types?.includes(cat);

        const matchText =
            !txtField ||
            item.name.toLowerCase().includes(txtField.toLowerCase());

        return matchCategory && matchText;
        });

        setMenusListFilter(filtered);
    };

    const searchChange = (e) =>{
        const lowerCase = e.target.value.toLowerCase();
        setSearchTxt(lowerCase);
        filterMenus(catSelect,lowerCase);
    }

    const changeFilterMenu = (cat) =>{
        setCatSelect(cat)
        filterMenus(cat,searchTxt);
    }


    useEffect(()=>{
        getEvents();
        getMenus();
    },[])

    return (
        <LayoutPages>
            <TitlePage title={'Programe sus menus'} />

            <div className="inlineBlock pageMenuCont">
                <DataState
                    status={status}
                    isEmpty={false}
                    onRetry={getEvents}
                    variant="list"
                    skeletonCount={4}
                >
                {/* Mes completo, de lunes a viernes.
                    Sabado y domingo no hay reparto: ocupaban dos septimos del
                    ancho vacios, y eran justo el espacio que le faltaba a los
                    nombres de los platos para no salir cortados. */}
                <div className="cal">
                  <div className="cal__barra">
                    <button type="button" className="cal__nav"
                      onClick={()=>setDate(moment(date).subtract(1,'month').toDate())}>‹</button>
                    <span className="cal__mes">{mesLargo(date)}</span>
                    <button type="button" className="cal__nav"
                      onClick={()=>setDate(moment(date).add(1,'month').toDate())}>›</button>
                    <button type="button" className="cal__hoy" onClick={()=>setDate(new Date())}>Hoy</button>
                  </div>

                  <div className="cal__cabecera">
                    {['Lunes','Martes','Miércoles','Jueves','Viernes'].map((d)=>(
                      <span key={d}>{d}</span>
                    ))}
                  </div>

                  <div className="cal__grilla">
                    {semanasDelMes(date).map((semana)=>
                      semana.map((dia)=>{
                        const clave = dia.format('YYYY-MM-DD');
                        const menu = menuPorDia[clave];
                        const delMes = dia.month() === moment(date).month();
                        const esHoy = dia.isSame(moment(),'day');
                        return (
                          <button type="button" key={clave}
                            className={[
                              'cal__dia',
                              delMes ? '' : 'cal__dia--fuera',
                              esHoy ? 'cal__dia--hoy' : '',
                              /* Programado a medias: tres platos es lo normal.
                                 Con dos, alguien se quedo sin terminar el dia y
                                 nadie se entera hasta que el cliente abre el app. */
                              menu && menu.platos.length > 0 && menu.platos.length < 3 ? 'cal__dia--incompleto' : '',
                              menu && menu.platos.length > 0 ? 'cal__dia--lleno' : '',
                            ].filter(Boolean).join(' ')}
                            onClick={()=>{
                              /* Misma forma que mandaba el calendario anterior,
                                 para no tocar el modal. */
                              const d = dia.toDate();
                              setDateSelect({ start: d, end: d, slots: [d] });
                              handleOpen();
                            }}>
                            <span className="cal__num">{dia.format('D')}</span>

                            {menu && menu.platos.length > 0 ? (
                              <>
                                <ol className="cal__platos">
                                  {menu.platos.map((p,i)=>(
                                    /* Cada opcion con su color, el mismo todo el
                                       mes: asi "la 2" se reconoce de un vistazo
                                       sin leer, que es como se mira un mes
                                       entero de corrido. */
                                    <li key={p.id}>
                                      <b className={`cal__op cal__op--${i+1}`}>{i+1}</b>{p.nombre}
                                    </li>
                                  ))}
                                </ol>
                                {menu.extras.length > 0 &&
                                  <p className="cal__extras">
                                    {menu.extras.map((e)=>(
                                      <span key={e.tipo+e.nombre}>
                                        <i className={`cal__ex cal__ex--${e.tipo}`}>{ETIQUETA[e.tipo] || e.tipo}</i> {e.nombre}
                                      </span>
                                    ))}
                                  </p>}
                              </>
                            ) : (
                              <span className="cal__vacio">+ Programar</span>
                            )}
                            {menu && menu.platos.length > 0 && menu.platos.length < 3 &&
                              <span className="cal__aviso">Faltan platos</span>}
                          </button>
                        );
                      })
                    )}
                  </div>
                </div>
                </DataState>
            </div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ModalRightCont addClass="modalRightCont--plano">
                
                    <ProgramAddDay 
                        date={dateSelect && fechaLarga(dateSelect.slots[0])}
                        menus={menusListFilter}
                        catalogo={menusList}
                        catFunc={changeFilterMenu}
                        dateSelect={dateSelect}
                        updateEvents={getEvents}
                        eventList={eventList}
                        closeModal={handleClose}
                    />
                
                </ModalRightCont>
            </Modal>
        </LayoutPages>
    )
};

export default PageProgram;
